(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["njf-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('njf-faq')) {
    customElements.define(
      'njf-faq',
      class extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('[data-njf-faq-qa]')];
          this.groups = [...this.querySelectorAll('[data-njf-faq-group]')];
          this.links = [...this.querySelectorAll('[data-njf-faq-nav]')];
          this.input = this.querySelector('[data-njf-faq-search]');
          this.status = this.querySelector('[data-njf-faq-status]');
          this.empty = this.querySelector('[data-njf-faq-empty]');
          this.items.forEach((qa) => (qa.dataset.text = qa.textContent.toLowerCase().replace(/\s+/g, ' ')));

          if (this.input) {
            this.input.addEventListener('input', () => this.filter(this.input.value));
          }

          // Keep the URL pointing at the open question, so it can be shared
          this.items.forEach((qa) =>
            qa.addEventListener('toggle', () => {
              if (qa.open && !this.searching) history.replaceState(null, '', '#' + qa.id);
            })
          );

          this.measureTop();
          let ticking = false;
          const remeasure = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              ticking = false;
              this.measureTop();
            });
          };
          window.addEventListener('scroll', remeasure, { passive: true });
          window.addEventListener('resize', remeasure);

          this.openFromHash();
          window.addEventListener('hashchange', () => this.openFromHash());
          this.watchGroups();
        }

        // Stick the topic nav under whatever stays pinned at the top of the screen (the announcement bar,
        // plus the header if it's set to sticky). --header-height alone is wrong when the header scrolls away.
        measureTop() {
          let top = 0;
          const group = document.getElementById('header-group');
          const els = [group, ...(group ? group.children : []), ...document.querySelectorAll('header-component, [id*="header_announcements"]')];
          els.forEach((el) => {
            if (!el) return;
            const pos = getComputedStyle(el).position;
            if (pos !== 'fixed' && pos !== 'sticky') return;
            const r = el.getBoundingClientRect();
            if (r.height && r.top <= 1 && r.bottom > top) top = r.bottom;
          });
          this.style.setProperty('--njf-faq-top', Math.round(top) + 'px');
        }

        openFromHash() {
          const id = decodeURIComponent(location.hash.slice(1));
          if (!id) return;
          const target = this.querySelector('#' + CSS.escape(id));
          if (!target) return;
          if (target.matches('[data-njf-faq-qa]')) target.open = true;
          requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
        }

        filter(raw) {
          const q = raw.trim().toLowerCase();
          this.searching = q.length > 0;
          let shown = 0;
          this.items.forEach((qa) => {
            const words = q.split(/\s+/).filter(Boolean);
            const match = words.every((w) => qa.dataset.text.includes(w));
            qa.hidden = !match;
            if (this.searching) qa.open = match && q.length > 1;
            else qa.open = false;
            if (match) shown++;
          });
          this.groups.forEach((g) => (g.hidden = !g.querySelector('[data-njf-faq-qa]:not([hidden])')));
          this.empty.hidden = shown > 0;
          this.classList.toggle('is-searching', this.searching);
          if (this.status) {
            this.status.textContent = this.searching ? `${shown} ${shown === 1 ? 'answer' : 'answers'} for “${raw.trim()}”` : '';
          }
        }

        // Highlight the category in view
        watchGroups() {
          if (!this.links.length || !('IntersectionObserver' in window)) return;
          const byId = new Map(this.links.map((a) => [a.getAttribute('href').slice(1), a]));
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                if (!e.isIntersecting) return;
                const link = byId.get(e.target.id);
                if (!link) return;
                this.links.forEach((a) => a.removeAttribute('aria-current'));
                link.setAttribute('aria-current', 'true');
                if (link.parentElement.parentElement.scrollWidth > link.parentElement.parentElement.clientWidth) {
                  link.scrollIntoView({ block: 'nearest', inline: 'center' });
                }
              });
            },
            { rootMargin: '-30% 0px -60% 0px' }
          );
          this.groups.forEach((g) => g.id && observer.observe(g));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["njf-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.njfNewsSignup) return;
    window.njfNewsSignup = true;

    /* Email: the button opens the inline box; put the cursor in it */
    document.addEventListener('toggle', function (e) {
      var mini = e.target;
      if (!mini.classList || !mini.classList.contains('njf-news__mini') || !mini.open) return;
      var input = mini.querySelector('.njf-news__input');
      if (input) input.focus();
    }, true);

    /* Texts: open the Klaviyo signup form */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-njf-sms-form]');
      if (!btn) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', btn.dataset.njfSmsForm]);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["njf-product-care"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('njf-care')) {
    customElements.define(
      'njf-care',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[data-njf-care-tab]')];
          this.panels = [...this.querySelectorAll('[data-njf-care-panel]')];
          this.bar = this.querySelector('[data-njf-care-bar]');
          this.wrap = this.querySelector('[data-njf-care-panels]');
          if (!this.tabs.length) return;

          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i, { user: true }));
            tab.addEventListener('keydown', (e) => {
              const last = this.tabs.length - 1;
              const to = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: last }[e.key];
              if (to === undefined) return;
              e.preventDefault();
              const next = to > last ? 0 : to < 0 ? last : to;
              this.select(next, { user: true });
              this.tabs[next].focus();
            });
          });

          // Keep the URL pointing at the open question, so it can be shared
          this.querySelectorAll('[data-njf-care-qa]').forEach((qa) =>
            qa.addEventListener('toggle', () => {
              if (qa.open) history.replaceState(null, '', '#' + qa.id);
            })
          );

          this.measureTop();
          let ticking = false;
          const remeasure = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              ticking = false;
              this.measureTop();
            });
          };
          window.addEventListener('scroll', remeasure, { passive: true });
          window.addEventListener('resize', remeasure);

          // Panels are only hidden once the tabs work, so the page still reads top to bottom without JS
          this.classList.add('is-ready');
          if (!this.openFromHash()) this.select(0);
          window.addEventListener('hashchange', () => this.openFromHash());

          // Theme editor: show the tab of the block being edited
          document.addEventListener('shopify:block:select', (e) => {
            const panel = e.target.closest && e.target.closest('[data-njf-care-panel]');
            if (!panel || !this.contains(panel)) return;
            this.select(this.panels.indexOf(panel));
            if (e.target.matches('[data-njf-care-qa]')) e.target.open = true;
          });
        }

        // Stick the tab bar under whatever stays pinned at the top of the screen (the announcement bar,
        // plus the header if it's set to sticky). --header-height alone is wrong when the header scrolls away.
        measureTop() {
          let top = 0;
          const group = document.getElementById('header-group');
          const els = [group, ...(group ? group.children : []), ...document.querySelectorAll('header-component, [id*="header_announcements"]')];
          els.forEach((el) => {
            if (!el) return;
            const pos = getComputedStyle(el).position;
            if (pos !== 'fixed' && pos !== 'sticky') return;
            const r = el.getBoundingClientRect();
            if (r.height && r.top <= 1 && r.bottom > top) top = r.bottom;
          });
          this.top = Math.round(top);
          this.style.setProperty('--njf-care-top', this.top + 'px');
          if (this.bar) this.style.setProperty('--njf-care-bar', this.bar.offsetHeight + 'px');
        }

        select(index, { user = false } = {}) {
          if (index < 0 || index >= this.panels.length) return;
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
            if (on && tab.parentElement.scrollWidth > tab.parentElement.clientWidth) {
              tab.parentElement.scrollTo({ left: tab.offsetLeft - (tab.parentElement.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
            }
          });
          this.panels.forEach((panel, i) => (panel.hidden = i !== index));
          if (!user) return;
          history.replaceState(null, '', '#' + this.panels[index].id);
          // Scrolled down into a long panel: bring the start of the new one up under the tab bar
          const offset = this.top + (this.bar ? this.bar.offsetHeight : 0);
          const r = this.wrap.getBoundingClientRect();
          if (r.top < offset) window.scrollTo({ top: window.scrollY + r.top - offset, behavior: 'smooth' });
        }

        openFromHash() {
          const id = decodeURIComponent(location.hash.slice(1));
          if (!id) return false;
          const target = this.querySelector('#' + CSS.escape(id));
          if (!target) return false;
          const panel = target.closest('[data-njf-care-panel]');
          if (!panel) return false;
          this.select(this.panels.indexOf(panel));
          if (target.matches('[data-njf-care-qa]')) {
            target.open = true;
            requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
          } else {
            requestAnimationFrame(() => (this.bar || panel).scrollIntoView({ block: 'start' }));
          }
          return true;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
